/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EventName = {
    AuthenticationSucceededV1: 'AuthenticationSucceeded_v1',
    AuthenticationFailedV1: 'AuthenticationFailed_v1',
    PersonCreatedV1: 'PersonCreated_v1',
    AnonymousPersonCreatedV1: 'AnonymousPersonCreated_v1',
    PersonDeletedV1: 'PersonDeleted_v1',
    VirtualPageLoadedV1: 'VirtualPageLoaded_v1',
    SlashIdsdkLoadedV1: 'SlashIDSDKLoaded_v1',
    PersonIdentifiedV1: 'PersonIdentified_v1',
    PersonLoggedOutV1: 'PersonLoggedOut_v1',
    TokenMintedV1: 'TokenMinted_v1',
    AnonymousTokenMintedV1: 'AnonymousTokenMinted_v1',
    PasswordChangedV1: 'PasswordChanged_v1',
    GdprConsentsChangedV1: 'GdprConsentsChanged_v1',
    GateServerStartedV1: 'GateServerStarted_v1',
    GateRequestHandledV1: 'GateRequestHandled_v1',
    GateRequestCredentialFoundV1: 'GateRequestCredentialFound_v1',
    PermissionCreatedInRegionV1: 'PermissionCreated_InRegion_v1',
    PermissionCreatedV1: 'PermissionCreated_v1',
    PermissionDeletedInRegionV1: 'PermissionDeleted_InRegion_v1',
    PermissionDeletedV1: 'PermissionDeleted_v1',
    RoleCreatedInRegionV1: 'RoleCreated_InRegion_v1',
    RoleCreatedV1: 'RoleCreated_v1',
    RoleDeletedInRegionV1: 'RoleDeleted_InRegion_v1',
    RoleDeletedV1: 'RoleDeleted_v1',
    RoleUpdatedInRegionV1: 'RoleUpdated_InRegion_v1',
    RoleUpdatedV1: 'RoleUpdated_v1',
    RolesSetToPersonInRegionV1: 'RolesSetToPerson_InRegion_v1',
    RolesSetToPersonV1: 'RolesSetToPerson_v1',
    PermissionsSetToPersonInRegionV1: 'PermissionsSetToPerson_InRegion_v1',
    PermissionsSetToPersonV1: 'PermissionsSetToPerson_v1',
    MitmAttackDetectedV1: 'MitmAttackDetected_v1',
    PermissionUpdatedInRegionV1: 'PermissionUpdated_InRegion_v1',
    PermissionUpdatedV1: 'PermissionUpdated_v1'
} as const;
export type EventName = typeof EventName[keyof typeof EventName];


export function EventNameFromJSON(json: any): EventName {
    return EventNameFromJSONTyped(json, false);
}

export function EventNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventName {
    return json as EventName;
}

export function EventNameToJSON(value?: EventName | null): any {
    return value as any;
}

